module.exports = __webpack_public_path__ + "img/pow-logo.334e6fb.png";